import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to the top whenever the route pathname changes.
 * Mount once inside <BrowserRouter>. Skips scroll if the URL contains a hash
 * (e.g. /page#section) so in-page anchors still work.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // preserve hash-link scrolling
    // Use 'auto' so navigation feels instant (smooth scroll on long pages can feel sluggish)
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
